import {
    IWorkflowStep,
    WorkflowStatus,
    WorkflowStepStatus,
} from "store/workflows/workflows-types";

const terminalStepStatuses: ReadonlySet<WorkflowStepStatus> = new Set([
    WorkflowStepStatus.Completed,
    WorkflowStepStatus.Failed,
    WorkflowStepStatus.Skipped,
]);

const completedWorkflowStatuses: ReadonlySet<WorkflowStatus> = new Set([
    WorkflowStatus.Succeeded,
    WorkflowStatus.Failed,
    WorkflowStatus.Terminated,
]);

const inProgressWorkflowStatuses: ReadonlySet<WorkflowStatus> = new Set([
    WorkflowStatus.NotStarted,
    WorkflowStatus.InProgress,
]);

export interface WorkflowProgress {
    completed: number;
    total: number;
    percent: number;
}

export const getWorkflowProgress = (
    steps: ReadonlyArray<IWorkflowStep> | undefined
): WorkflowProgress => {
    const total = steps?.length ?? 0;
    const completed =
        steps?.filter((step) => terminalStepStatuses.has(step.status)).length ??
        0;

    return {
        completed,
        total,
        percent: total === 0 ? 0 : (completed / total) * 100,
    };
};

export const isCompleted = (status?: WorkflowStatus | null): boolean =>
    status ? completedWorkflowStatuses.has(status) : false;

export const isInProgress = (status?: WorkflowStatus | null): boolean =>
    status ? inProgressWorkflowStatuses.has(status) : false;

export const isInTerminated = (status?: WorkflowStatus | null): boolean =>
    status === WorkflowStatus.Terminated;

export const hasFailedSteps = (
    steps: ReadonlyArray<IWorkflowStep> | undefined
): boolean =>
    steps?.some((step) => step.status === WorkflowStepStatus.Failed) ?? false;

export const hasSkippedSteps = (
    steps: ReadonlyArray<IWorkflowStep> | undefined
): boolean =>
    steps?.some((step) => step.status === WorkflowStepStatus.Skipped) ?? false;
